import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { hasRoleAccess } from "../utils/roleAccess";

/**
 * Garde de route : permission précise (ex. 'USER_LIST') ET règles par rôle
 * (allowRoles / denyRoles / rolesExcept), mêmes règles que le menu
 * (filterMenuByPermissions dans Menu.js) et que le backend (permit(...)).
 * Le SUPER_ADMIN passe toujours le test de permission, mais reste soumis aux
 * règles de rôle (il n'a pas de tableau de bord enseignant ou étudiant).
 */
const PermissionRoute = ({ permission, allowRoles, denyRoles, rolesExcept }) => {
  const auth = useSelector((state) => state.auth.auth);

  const isAuthenticated = auth?.accessToken;
  const permissions = auth?.user?.permissions || [];
  const roles = auth?.user?.roles || [];

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!hasRoleAccess({ roles: allowRoles, denyRoles, rolesExcept }, roles)) {
    return <Navigate to="/page-error-403" replace />;
  }

  if (permission && !roles.includes("SUPER_ADMIN") && !permissions.includes(permission)) {
    return <Navigate to="/page-error-403" replace />;
  }

  return <Outlet />;
};

export default PermissionRoute;